import * as React from 'react';

const { Component } = React;

import { createOrganization } from './OrganizationStore';

export default class CreateOrganization extends Component {
    state = {
        organization: {
            id: undefined,
            name: undefined
        },
        isLoaded: false
    };

    constructor(props) {
        super(props);
    }

    createOrganization = (event) => {
        event.preventDefault();
        if (event.target.name) {

            var data = {
                Name: event.target.name.value
            }

            createOrganization(data)
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            organization: result
                        });
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }

    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <form onSubmit={this.createOrganization}>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Name</label>
                        <div className="col-sm-9 pl-0">
                            <input type="text" className="form-control" name="name" />
                        </div>
                    </div>
                    <button className="btn btn-primary float-right" type="submit">Create</button>
                </form>
                {this.state.isLoaded &&
                    <div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">ID</label>
                            <div className="col-sm-9 p-2">
                                {this.state.organization.id}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Name</label>
                            <div className="col-sm-9 p-2">
                                {this.state.organization.name}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}